import AbsPresenter from "@/utils/common/AbsPresenter.ts";
import {CustomDTOExpression} from "@/utils/presenters/interfaces.ts";
import {ModelRef} from "vue";
import CriteriaUtils from "@/utils/criteria/CriteriaUtils.ts";
import DTOCriteria = namaTypes.DTOCriteria;

export default class CriteriaWidgetPresenter extends AbsPresenter
{
  model: ModelRef<CustomDTOExpression | undefined>
  criteriaFields: namaTypes.CriteriaField[] | undefined

  constructor(model: ModelRef<CustomDTOExpression | undefined>, criteriaFields: namaTypes.CriteriaField[] | undefined, ownerEntity?: string) {
    super(undefined);
    this.model = model;
    this.criteriaFields = criteriaFields;
    if (ownerEntity)
      this._entityType = ownerEntity;
  }

  override fetchRecord(): Record<string, any> {
    return this.model.value!;
  }

  override fetchCriteriaFromFilterField(filteredType?: string): namaTypes.DTOCriteria | undefined {
    let field = this.criteriaFields?.find(l => l.id === this.model.value!.field!)
    if (!field)
      return undefined;
    let expressions = CriteriaUtils.criteriaStrToMap(field.criteriaExpression)
    let strExpression;
    if (filteredType)
      strExpression = expressions[filteredType];
    if (!strExpression)
      strExpression = expressions[""];
    if (!strExpression)
      return undefined;
    return CriteriaUtils.criteriaFromStr(strExpression);
  }

  override getDefaultCriteria(fieldId?: string): DTOCriteria | undefined {
    return this.fetchCriteriaFromFilterField();
  }
}
